var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_2443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66665 19.6501C3.94922 19.0619 0.298828 15.0377 0.298828 10.1609C0.298828 4.87928 4.58042 0.597687 9.86205 0.597687C15.1437 0.597687 19.4253 4.87928 19.4253 10.1609C19.4253 15.0377 15.7749 19.0619 11.0574 19.6501V22.1288C15.7749 22.2391 19.4253 22.9937 19.4253 23.908C19.4253 24.8983 15.1437 25.7011 9.86205 25.7011C4.58042 25.7011 0.298828 24.8983 0.298828 23.908C0.298828 22.9937 3.94922 22.2391 8.66665 22.1288V19.6501ZM9.86205 17.3333C13.8233 17.3333 17.0345 14.1221 17.0345 10.1609C17.0345 6.19969 13.8233 2.98849 9.86205 2.98849C5.90083 2.98849 2.68963 6.19969 2.68963 10.1609C2.68963 14.1221 5.90083 17.3333 9.86205 17.3333Z",
    fill: "#343A33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.86208,
    cy: 9.86208,
    rx: 2.68966,
    ry: 2.68966,
    fill: "#88BDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_2443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7241,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartement);
export default __webpack_public_path__ + "static/media/departement.8f18979c2b892a07f856ec7b300a8c36.svg";
export { ForwardRef as ReactComponent };